import Icon from '../components/Icon.vue'

Icon.register({
  parking: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM240 320H192V368C192 376.8 184.8 384 176 384H144C135.2 384 128 376.8 128 368V144C128 135.2 135.2 128 144 128H240C292.9 128 336 171.1 336 224S292.9 320 240 320zM240 192H192V256H240C257.6 256 272 241.6 272 224S257.6 192 240 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/parking.js
// module id = c2vx
// module chunks = 144